module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAUklEQVQ4y2NgGBzActl/bJgQwDBAN2YbGJNlgHfxgf+HL7z6f+DcSzCbLBdcvfcBjMlyAafDyv9aUVvBmMdpFXkuIDsQr2rL/ScHjxqAZMDQBgAvSaASxV2Z/QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CL.png
// module id = 1111
// module chunks = 0